import { render, staticRenderFns } from "./PenNameSaveDialog.vue?vue&type=template&id=41f501be&scoped=true"
import script from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
export * from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
import style0 from "./PenNameSaveDialog.vue?vue&type=style&index=0&id=41f501be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f501be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f501be')) {
      api.createRecord('41f501be', component.options)
    } else {
      api.reload('41f501be', component.options)
    }
    module.hot.accept("./PenNameSaveDialog.vue?vue&type=template&id=41f501be&scoped=true", function () {
      api.rerender('41f501be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/PenNameSaveDialog.vue"
export default component.exports